import {BrowserTier, ProjectSubtype, ProjectType} from './types';

export const BROWSER_TIERS: Map<BrowserTier, string> = new Map([
  [BrowserTier.UNKNOWN_TIER, 'UNKNOWN_TIER'],
  [BrowserTier.TIER_1, 'TIER_1'],
  [BrowserTier.TIER_2, 'TIER_2'],
  [BrowserTier.TIER_3, 'TIER_3'],
]);

export const PROJECT_TYPES: Map<ProjectType, string> = new Map([
  [ProjectType.UNKNOWN_PROJECT_TYPE, 'UNKNOWN_PROJECT_TYPE'],
  [ProjectType.MULTIPLE_SINGLE_FAMILY_UNITS, 'MULTIPLE_SINGLE_FAMILY_UNITS'],
  [ProjectType.MULTIPLE_DWELLING_UNIT, 'MULTIPLE_DWELLING_UNIT'],
  [ProjectType.MULTI_STORIED_APARTMENTS, 'MULTI_STORIED_APARTMENTS'],
  [ProjectType.SMALL_MULTIPLE_DWELLING_UNIT, 'SMALL_MULTIPLE_DWELLING_UNIT'],
]);

export const PROJECT_SUBTYPES: Map<ProjectSubtype, string> = new Map([
  [ProjectSubtype.UNKNOWN_PROJECT_SUBTYPE, 'UNKNOWN_PROJECT_SUBTYPE'],
  [ProjectSubtype.STANDARD, 'STANDARD'],
  [ProjectSubtype.FIBER_INSIDE, 'FIBER_INSIDE'],
  [ProjectSubtype.AFFORDABLE_HOUSING, 'AFFORDABLE_HOUSING'],
]);
